import React, { useState } from 'react';
import { connect } from 'react-redux';

import InputAdornment from '@material-ui/core/InputAdornment';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Loader from 'components/Loader';
import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Store from 'services/StoreService';
import { updateUserData } from 'store/actions/userActions';
import { displayError } from 'store/actions/errorActions';
import capitalize from 'utils/capitalize';

const socialMedia = [
  { name: 'instagram', Icon: InstagramIcon },
  { name: 'facebook', Icon: FacebookIcon },
  { name: 'twitter', Icon: TwitterIcon },
];

const UserSocialAccounts = ({
  uid,
  history,
  displayError,
  socialAccounts,
  updateUserData,
}) => {
  const [input, setInput] = useState({});

  const handleChange = (e) => {
    setInput({
      ...input,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      await Store.updateUser(uid, { socialAccounts: input });
      updateUserData({ socialAccounts: input });
      history.push('/pick-genres');
    } catch (error) {
      console.log(error);
      displayError('Error saving the data');
    }
  };

  return !uid ? (
    <Loader />
  ) : (
    <GridContainer
      justify='center'
      style={{
        padding: '0 50px',
        textAlign: 'center',
      }}
    >
      <GridItem xs={12} sm={10} md={8} lg={6}>
        <h2>Social Accounts</h2>
        <form onSubmit={handleSubmit}>
          {[
            socialMedia.map(({ name, Icon }) => (
              <div key={name} style={{ padding: '30px 0' }}>
                <CustomInput
                  labelText={capitalize(name)}
                  id={name}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    type: 'text',
                    onChange: handleChange,
                    defaultValue: socialAccounts[name],
                    endAdornment: (
                      <InputAdornment position='end'>
                        <Icon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            )),
          ]}
          <Button
            style={{
              borderRadius: '50px',
              width: '200px',
              position: 'fixed',
              bottom: '30px',
              left: '50%',
              marginLeft: '-100px',
            }}
            type='submit'
            color='primary'
          >
            Let's Go
          </Button>
        </form>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => {
  const { user, error } = state;
  const { uid, socialAccounts } = user;
  return { uid, error, socialAccounts };
};

export default connect(mapStateToProps, { displayError, updateUserData })(
  UserSocialAccounts
);
